import { Vulnerability, VulnerabilityId } from '../Vulnerability';
import { Actions } from './store';

export const startGettingVulnerabilities = (applicantIndex: number) => {
  return {
    type:
      applicantIndex === 0
        ? Actions.SET_APPLICANT_1_VULNERABILITIES_START
        : Actions.SET_APPLICANT_2_VULNERABILITIES_START,
    payload: null,
  };
};

export const gettingVulnerabilitiesFinish = (applicantIndex: number, vulnerabilities: Vulnerability[]) => {
  return {
    type:
      applicantIndex === 0
        ? Actions.SET_APPLICANT_1_VULNERABILITIES_FINISH
        : Actions.SET_APPLICANT_2_VULNERABILITIES_FINISH,
    payload: vulnerabilities,
  };
};

export const gettingVulnerabilitiesError = (applicantIndex: number, error: string) => {
  return {
    type:
      applicantIndex === 0
        ? Actions.SET_APPLICANT_1_VULNERABILITIES_ERROR
        : Actions.SET_APPLICANT_2_VULNERABILITIES_ERROR,
    payload: error,
  };
};

export const addVulnerabilityFinish = (applicantIndex: number, vulnerability: Vulnerability) => ({
  type:
    applicantIndex === 0 ? Actions.ADD_APPLICANT_1_VULNERABILITY_FINISH : Actions.ADD_APPLICANT_2_VULNERABILITY_FINISH,
  payload: vulnerability,
});

export const deleteVulnerabilityStart = (applicantIndex: number, id: VulnerabilityId) => ({
  type:
    applicantIndex === 0
      ? Actions.DELETE_APPLICANT_1_VULNERABILITY_START
      : Actions.DELETE_APPLICANT_2_VULNERABILITY_START,
  payload: id,
});

export const deleteVulnerabilityError = (applicantIndex: number, id: VulnerabilityId) => ({
  type:
    applicantIndex === 0
      ? Actions.DELETE_APPLICANT_1_VULNERABILITY_ERROR
      : Actions.DELETE_APPLICANT_2_VULNERABILITY_ERROR,
  payload: id,
});

export const deleteVulnerabilityFinish = (applicantIndex: number, id: VulnerabilityId) => ({
  type:
    applicantIndex === 0
      ? Actions.DELETE_APPLICANT_1_VULNERABILITY_FINISH
      : Actions.DELETE_APPLICANT_2_VULNERABILITY_FINISH,
  payload: id,
});

export const setVulnerabilityInProgress = (applicantIndex: number, vulnerabilityId: VulnerabilityId) => {
  return {
    type:
      applicantIndex === 0
        ? Actions.APPLICANT_1_VULNERABILITY_IN_PROGRESS_START
        : Actions.APPLICANT_2_VULNERABILITY_IN_PROGRESS_START,
    payload: vulnerabilityId,
  };
};

export const setVulnerabilityInProgressFinish = (applicantIndex: number, vulnerabilityId: VulnerabilityId) => {
  return {
    type:
      applicantIndex === 0
        ? Actions.APPLICANT_1_VULNERABILITY_IN_PROGRESS_FINISH
        : Actions.APPLICANT_2_VULNERABILITY_IN_PROGRESS_FINISH,
    payload: vulnerabilityId,
  };
};

export const updateVulnerabilityFinish = (applicantIndex: number, vulnerability: Vulnerability) => ({
  type:
    applicantIndex === 0
      ? Actions.UPDATE_APPLICANT_1_VULNERABILITY_FINISH
      : Actions.UPDATE_APPLICANT_2_VULNERABILITY_FINISH,
  payload: vulnerability,
});
